import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  INITIAL_PAGE_RANGE,
  Pagination,
  PaginationProps,
} from "../pagination/pagination";
import { SpaceSummaryRow } from "./SpaceSummaryRow";
import { useState } from "react";
import { PaginationRange } from "../pagination";
import { SpaceSummaryData } from "./useSpaceSummary";

export type SpaceSummaryTableListProps = {
  spaceSummaries: SpaceSummaryData[];
  PaginationProps: Omit<PaginationProps, "setPageItems">;
};

export function SpaceSummaryTableList({
  spaceSummaries,
  PaginationProps,
}: SpaceSummaryTableListProps) {
  const [pageItems, setPageItems] =
    useState<PaginationRange>(INITIAL_PAGE_RANGE);

  const paginatedSummaries = spaceSummaries.slice(pageItems.from, pageItems.to);

  return (
    <Box className="space-summary-table-list">
      <Grid container spacing={3} mb={3}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="40%">Space</TableCell>
                <TableCell>Integrations</TableCell>
                <TableCell width="15%" align="right">
                  Asset Count
                </TableCell>
                <TableCell width="15%" align="right">
                  Priority Findings
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedSummaries.map((summary) => {
                return (
                  <SpaceSummaryRow key={summary.mrn} summaryData={summary} />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Pagination setPageItems={setPageItems} {...PaginationProps} />
    </Box>
  );
}
